import * as React from 'react';
import { AppNavLink } from 'src/models/Utility/AppNavLink';
import { SidebarLayout } from '../utility/components/SidebarLayout';

const MahjongNavLinks: AppNavLink[] = [
    { text: "Index", path: "/mahjong" },
    { text: "Game Test", path: "/mahjong/gameTest" },
    { text: "Tile Set", path: "/mahjong/tileSet" },
    { text: "Yaku List", path: "/mahjong/yaku" },
];

export function MahjongManager(): JSX.Element {
    return (
        <SidebarLayout links={MahjongNavLinks} />
    );
}
